<template>
    <b-container fluid id="tables">
        <b-row class="d-flex justify-content-center text-center">
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date1" />
            </b-col>
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date2" />
            </b-col>
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <b-input v-if="localUser.role == 'Shifokor'" v-model="doctor" disabled>
                </b-input>
                <v-select :options="names" v-model="datas.user_id" :reduce="names => names.id" label="user_name"
                    :placeholder="$t('Ҳодимни танланг...')" v-else />
            </b-col>
            <b-col xs="3" md="3" xl="3" class="my-3">
                <button type="button" class="btn text-white" style="background: #195FB0; width: 130px; font-size: 14px"
                    @click="Send()">
                    <img src="../../../public/Vector.png" alt="" style="margin-right: 5px" />
                    {{ $t("Кўриш") }}
                </button>
                <button class="btn text-white" style="background: #195FB0; width: 130px; margin-left: 10px; font-size: 14px" @click="downloadTable">Юклаш</button>
                <b-button class="navbarBtnDanger ml-3" variant="danger" @click="cancel()">
                    <b-icon icon="x-circle-fill"></b-icon>
                </b-button>
            </b-col>
            <!-- <b-col>
          
        </b-col> -->
        </b-row>
        <div class="tablesD">
            <table id="my-table" class="table  table-bordered table-sm table-striped">
                <tr class="bg-dark text-white" style="position: sticky; top: 1px; z-index: 1; background: #fff;">
                    <th>№</th>
                    <th>{{ $t("Ходим ФИО") }}</th>
                    <th>{{ $t("Вақт") }}</th>
                    <th>{{ $t("Изоҳ") }}</th>
                    <th>{{ $t("Нақт") }}</th>
                    <th>{{ $t("Пластик") }}</th>
                    <th>{{ $t("Клик") }}</th>
                    <th>{{ $t("Жами") }}</th>
                </tr>
                <tr v-for="(item, index) in results" :key="index">
                    <td>
                        {{ index + 1 }}
                    </td>
                    <td>
                        <span>{{ item.user.user_name }}</span>
                    </td>
                    <td>
                        {{ item.date_time | dateFormatDD }}
                    </td>
                    <td>
                        {{ item.comment }}
                    </td>
                    <td>
                        <span>
                            {{ item.naqd_summa | numFormat }}
                        </span>
                    </td>
                    <td>
                        <span>
                            {{ item.plastik_summa | numFormat }}
                        </span>
                    </td>
                    <td>
                        <span>
                            {{ item.click_summa | numFormat }}
                        </span>
                    </td>
                    <td>
                        <span>
                            {{ item.naqd_summa+item.plastik_summa+item.click_summa | numFormat }}
                        </span>
                    </td>
                </tr>
            </table>
        </div>
    </b-container>
</template>

<script>
import moment from "moment";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
export default {
    data() {
        return {
            datas: {
                date1: new Date().toISOString().slice(0, 8) + "01",
                date2: new Date().toISOString().slice(0, 10),
                user_id: null
            },
            results: [],
            names: [],
            localUser: JSON.parse(localStorage.getItem("user"))
        };
    },
    filters: {
        dateFormatDD: function (date) {
            if (date != null) {
                return moment(new Date(date * 1000)).format("DD.MM.YYYY HH:mm");
            } else {
                return "";
            }
        }
    },
    created() {
        let self = this;
        if (
            JSON.parse(localStorage.getItem("datas")) &&
            self.localUser.role != "Shifokor"
        ) {
            self.datas.date1 = JSON.parse(localStorage.getItem("datas")).date1;
            self.datas.date2 = JSON.parse(localStorage.getItem("datas")).date2;
            self.datas.user_id = JSON.parse(
                localStorage.getItem("datas")
            ).user_id;
            self.Send();
            localStorage.removeItem("datas");
        }
        if (self.localUser.role == "Shifokor") {
            self.datas.user_id = self.localUser.doctor.id;
            self.doctor = self.localUser.doctor.name;
        }
    },
    methods: {
        Send() {
            let self = this;
            var datas = {
                datetime1: parseInt(
                    new Date(self.datas.date1)
                        .valueOf()
                        .toString()
                        .slice(0, 10)
                ),
                datetime2:
                    parseInt(
                        new Date(self.datas.date2)
                            .valueOf()
                            .toString()
                            .slice(0, 10)
                    ) + 86399,
                user_id: self.datas.user_id
            };
            axios({
                method: "post",
                url: "hisobot/hodim_oylik",
                data: datas
            }).then(function (res) {
                if(!res.data.error){
                    self.results = res.data.data;
                }
            });
        },
        cancel() {
            window.close();
        },
        getDoctor() {
            let self = this;
            axios({
                method: "get",
                url: "/user/all"
            }).then(res => {
                if (!res.error) {
                    res.data.data.forEach(el => {
                        if (el.role !== "Admin") {
                            self.names.push(el);
                        }
                    });
                }
            });
        },
        async downloadTable() {
            try {
            let wb = XLSX.utils.table_to_book(document.getElementById("my-table")),
            wopts = {
                bookType: "xlsx",
                bookSST: false,
                type: "binary"
            };
            var wscols = [{ width: 5 },{ width: 20 },{ width: 12 },{ width: 25 },{ width: 20 },{ width: 25 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 }]; 
            wb.Sheets.Sheet1['!cols']=wscols;
            let wbout = XLSX.write(wb, wopts);
            FileSaver.saveAs(
            new Blob([this.s2ab(wbout)], {
                type: "application/octet-stream;charset=utf-8",
            }), new Date() + "Xodimlar_oylik.xlsx");
            } catch (error) {
            console.error("Error loading XLSX module:", error);
            }
        },
        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
    },
    mounted() {
        this.getDoctor();
    }
};
</script>

<style scoped>
.table {
    margin: 0px 0px !important;
}

/* .tablesD {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 395px;
    width: 100%;
  } */
label,
td,
th,
tr {
    font-family: "Times New Roman", Times, serif;
    font-weight: bolder;
    text-transform: capitalize;
    font-size: 15px;
    height: 30px !important;
    text-align: center;
}

.ShifokrSverka {
    border-radius: 3px;
    background: #fff;
    border: 1px solid rgb(210, 210, 210);
}

.navbarBtnDanger {
    border: 1px solid #fff;
    /* box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.3); */
    background: #e80a18;
    border-radius: 8px;
}

.reds {
    color: red;
}

#tables {
    height: 100vh !important;
    width: 99% !important;
}

th {
    color: #195fb0;
    background-color: #f4f7fb;
}
</style>